import React, { useEffect, useState } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import UserBlackImage from "../../../../assets/images/user_black.png";
import axios from "axios";
import * as Constants from "../../../../constants/urls";
import { useCookies } from "react-cookie";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const UserLimiter = (props) => {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [usersState, setUsersState] = useState([]);

    const [alertOpen, setAlertOpen] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [alertMessage, setAlertMessage] = useState("");

    const [cookies, setCookie, removeCookie] = useCookies();

    const [selectedSegment, setSelectedSegment] = useState(null);
    const [segments, setSegments] = useState([]);
    const [segmentLoading, setSegmentLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const users = null;
    const vertical = "bottom";
    const horizontal = "left";

    const handleClose = () => {
        setAlertOpen(false);
    };

    const addButtonClicked = () => {
        if (phoneNumber.trim() !== "") {
            setLoading(true);
            axios
                .post(
                    Constants.apiUrl + "/api/add-dependency-to-discount",
                    {
                        discountId: props.discountId,
                        dependencyId: phoneNumber,
                        dependencyType:
                            props.typeId == 6 ? "class_user" : "user",
                        isForClass: props.typeId == 6 ? true : false,
                    },
                    {
                        headers: {
                            Authorization:
                                "Bearer " + cookies.user_server_token,
                        },
                    },
                )
                .then((response) => {
                    if (response.data.status === "done") {
                        let usersArray = [...usersState];
                        usersArray.push({
                            id: response.data.id,
                            username: response.data.username,
                            name: response.data.name,
                        });
                        setUsersState(usersArray);
                        setAlertSeverity("success");
                        setAlertMessage("عملیات با موفقیت انجام شد");
                    } else if (response.data.status === "failed") {
                        if (response.data.source === "m") {
                            window.location.href = Constants.siteUrl;
                        } else {
                            setAlertSeverity("warning");
                            if (
                                response.data.message === "dependency not found"
                            ) {
                                setAlertMessage(
                                    "کاربر با چنین شماره تماس یافت نشد",
                                );
                            } else if (
                                response.data.message === "dependency exists"
                            ) {
                                setAlertMessage("این کاربر در لیست وجود دارد");
                            }
                            console.log(response.data.umessage);
                        }
                    }
                    setAlertOpen(true);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                    setAlertSeverity("error");
                    setAlertMessage("مشکلی در اتصال رخ داده است");
                    setAlertOpen(true);
                    setLoading(false);
                });
        } else {
            setAlertSeverity("warning");
            setAlertMessage("شماره تلفن کاربر را به درستی وارد کنید");
            setAlertOpen(true);
        }
    };

    const phoneNumberInputChanged = (event) => {
        setPhoneNumber(event.target.value);
        console.log(usersState);
    };

    useEffect(() => {
        axios
            .post(
                Constants.apiUrl + "/api/discount-relevant-dependencies",
                {
                    discountId: props.discountId,
                    dependencyType: props.typeId == 6 ? "class_user" : "user",
                    isForClass: props.typeId == 6 ? true : false,
                },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((response) => {
                if (response.data.status === "done") {
                    let usersArray = response.data.users;
                    let array1 = [];
                    usersArray.map((usr) => {
                        array1.push(usr);
                    });
                    setUsersState(array1);
                } else if (response.data.status === "failed") {
                    if (response.data.source === "m") {
                        window.location.href = Constants.siteUrl;
                    } else {
                        setAlertSeverity("warning");
                        if (response.data.message === "discount not found") {
                            setAlertMessage("چنین تخفیفی پیدا نشد");
                        } else if (
                            response.data.message === "not enough parameter"
                        ) {
                            setAlertMessage("ورودی به اندازه کافی نیست");
                        }
                        setAlertOpen(true);
                        console.log(response.data.umessage);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                setAlertSeverity("error");
                setAlertMessage("مشکلی در اتصال رخ داده است");
                setAlertOpen(true);
            });
    }, []);

    useEffect(() => {
        setSegmentLoading(true);
        setSegments([]);
        axios
            .get(Constants.apiUrl + "/api/all-segments", {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((response) => {
                // if (response.data.status === "done") {
                //     setProvinces(response.data.provinces);
                // }
                setSegments(response.data.segments);
                console.log(response);
                setSegmentLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setAlertSeverity("error");
                setAlertMessage("مشکلی در اتصال رخ داده است");
                setAlertOpen(true);
                setSegmentLoading(false);
            });
    }, []);

    const deleteBtnClicked = (id) => {
        axios
            .post(
                Constants.apiUrl + "/api/remove-dependency-from-discount",
                {
                    dependencyId: id,
                },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((response) => {
                if (response.data.status === "done") {
                    let usersArray = [];
                    for (let usr of usersState) {
                        if (usr.id !== id) {
                            usersArray.push(usr);
                        }
                    }
                    setUsersState(usersArray);
                } else if (response.data.status === "failed") {
                    if (response.data.source === "m") {
                        window.location.href = Constants.siteUrl;
                    } else {
                        setAlertSeverity("warning");
                        setAlertMessage("مشکلی پیش آمده");
                        setAlertOpen(true);
                        console.log(response.data.umessage);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                setAlertSeverity("error");
                setAlertMessage("مشکلی در اتصال رخ داده است");
                setAlertOpen(true);
            });
    };

    const addSegmentButtonClicked = () => {
        console.log("mohammad selected segment is here", selectedSegment);
        if (selectedSegment != null) {
            setLoading(true);
            axios
                .post(
                    Constants.apiUrl + "/api/segment-contacts",
                    {
                        segmentAlias: selectedSegment,
                        discountId: props.discountId,
                        dependencyType:
                            props.typeId == 6 ? "class_user" : "user",
                        isForClass: props.typeId == 6 ? true : false,
                    },
                    {
                        headers: {
                            Authorization:
                                "Bearer " + cookies.user_server_token,
                        },
                    },
                )
                .then((response) => {
                    if (response.data.status === "done") {
                        setUsersState([
                            ...usersState,
                            ...response.data.contacts,
                        ]);
                        setAlertSeverity("success");
                        setAlertMessage("عملیات با موفقیت انجام شد");
                        // setProvinces(response.data.contacts);
                    }
                    console.log(response);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                    setAlertSeverity("error");
                    setAlertMessage("مشکلی در اتصال رخ داده است");
                    setAlertOpen(true);
                    setLoading(false);
                });
        }
    };

    return (
        <React.Fragment>
            <div className={["container-fluid"].join(" ")}>
                <img
                    src={UserBlackImage}
                    className={["mt-2"].join(" ")}
                    style={{ width: "40px" }}
                />
                <div
                    className={["row", "mt-2"].join(" ")}
                    style={{ direction: "ltr" }}
                >
                    <button
                        className={`btn ${
                            loading ? "btn-success" : "btn-outline-success"
                        } col-2`}
                        onClick={addButtonClicked}
                    >
                        {loading ? "لطفا کمی صبر کنید" : "افزودن"}
                    </button>
                    {/* <Autocomplete
                        className={[
                            "col-10",
                            "text-right",
                            "justify-content-right",
                            "d-none",
                        ].join(" ")}
                        style={{ direction: "rtl" }}
                        onChange={(event, newValue) => {
                            console.log(newValue);
                        }}
                        id="controllable-states-demo"
                        options={users}
                        getOptionLabel={(users) =>
                            users.name + " : " + users.phone
                        }
                        renderInput={(params) => (
                            <TextField
                                className={["text-right"].join(" ")}
                                {...params}
                                label="اطلاعات کاربر"
                                variant="outlined"
                                style={{
                                    direction: "ltr",
                                    fontFamily: "IranSansWebFaNum",
                                }}
                            />
                        )}
                    /> */}
                    <input
                        typet="text"
                        className={[
                            "form-control",
                            "col-10",
                            "text-right",
                        ].join(" ")}
                        placeholder="تلفن همراه کاربر"
                        onChange={phoneNumberInputChanged}
                    />
                </div>
                <div className="row mt-3" style={{ direction: "ltr" }}>
                    <button
                        className={`btn ${
                            loading ? "btn-success" : "btn-outline-success"
                        } col-2`}
                        onClick={addSegmentButtonClicked}
                    >
                        {segmentLoading
                            ? "درحال دریافت اطلاعات"
                            : loading
                            ? "لطفا کمی صبر کنید"
                            : "افزودن"}
                    </button>
                    <Autocomplete
                        className={[
                            "col-10",
                            "text-right",
                            "justify-content-right",
                            "mt-0",
                            "p-0",
                        ].join(" ")}
                        style={{
                            direction: "rtl",
                            fontFamily: "IranSansWebFaNum",
                        }}
                        loading={segmentLoading}
                        onChange={(event, newValue) => {
                            if (newValue !== null) {
                                setSelectedSegment(newValue.id);
                            } else {
                                setSelectedSegment(null);
                            }
                        }}
                        id="controllable-states-demo"
                        noOptionsText="..."
                        options={segments}
                        getOptionLabel={(segments) => segments.name}
                        renderInput={(params) => (
                            <TextField
                                className={["text-right"].join(" ")}
                                {...params}
                                variant="outlined"
                                style={{
                                    fontFamily: "IranSansWebFaNum",
                                    direction: "rtl",
                                }}
                            />
                        )}
                    />
                </div>
                {usersState.map((usr, counter) => {
                    return (
                        <div
                            key={counter}
                            className={[
                                "row",
                                "mt-2",
                                "rounded",
                                "align-items-center",
                            ].join(" ")}
                            style={{ backgroundColor: "#f2f2f2" }}
                        >
                            <p
                                className={["text-center", "m-0", "col-1"].join(
                                    " ",
                                )}
                            >
                                {counter + 1}
                            </p>
                            <p
                                className={["text-center", "m-0", "col-4"].join(
                                    " ",
                                )}
                            >
                                {usr.name}
                            </p>
                            <p
                                className={["text-center", "m-0", "col-5"].join(
                                    " ",
                                )}
                            >
                                {usr.username}
                            </p>
                            <button
                                className={[
                                    "btn",
                                    "btn-outline-danger",
                                    "col-2",
                                ].join(" ")}
                                onClick={() => {
                                    deleteBtnClicked(usr.id);
                                }}
                            >
                                {loading ? "لطفا کمی صبر کنید" : "حذف"}
                            </button>
                        </div>
                    );
                })}
            </div>
            <Snackbar
                open={alertOpen}
                onClose={handleClose}
                message="I love snacks"
                autoHideDuration={1500}
                anchorOrigin={{ vertical, horizontal }}
            >
                <Alert severity={alertSeverity} icon={false}>
                    {alertMessage}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
};

export default UserLimiter;
